import { useState } from 'react'

const useLatencyTest = (initValue = 'init') => {
  const [isConnectedFast, setIsConnectedFast] = useState(initValue)
  const debug = false

  if(!debug && navigator && navigator.connection && navigator.connection.downlink) {
    if('init'  === isConnectedFast) {
      setIsConnectedFast(navigator.connection.downlink > pmkinoFrontVars.cinemaData.front.latency_test.navigator_connection_downlink)
    }
  } else {
    const arrTimes = []
    const timesToTest = 5
    const tThreshold = pmkinoFrontVars.cinemaData.front.latency_test.time_threshold //ms
    const testImage =  window.location.protocol + '//' + window.location.hostname + '/wp-content/themes/pmkino/assets-static/px.gif'
    const dummyImage = new Image()
    let i = 0

    testLatency(function(avg) {
        setIsConnectedFast((avg <= tThreshold))
    })

    function testLatency(cb) {
        const tStart = new Date().getTime()
      
        if(i < timesToTest - 1) {
          dummyImage.src = testImage + '?t=' + tStart;
          dummyImage.onload = function() {
            const tEnd = new Date().getTime()
            const tTimeTook = tEnd - tStart
            arrTimes[i] = tTimeTook
            testLatency(cb)
            i++
          }
        } else {
          const sum = arrTimes.reduce(function(a, b) { return a + b });
          const avg = sum / arrTimes.length
          cb(avg)
        }
    }
  }

  return isConnectedFast
}

export default useLatencyTest



// time_threshold